<template>
    <div class="bg">
        <div class="h-100 d-flex flex-column justify-center align-center">
            <div class="logo-circle d-flex justify-center align-center my-2">
                <img :src="whiteLogo" alt="logo" width="80" />
            </div>
            <span class="white--text my-2">
                {{ core.username }} مرحبا
            </span>
            <v-btn
                class="rounded-BigLg my-2"
                color="secondary"
                @click="isStart = true; startOrEndTransport(isStart)"
                :loading="submitLoading && isStart"
                :disabled="submitLoading && !isStart"
            >
                بدء رحلة الذهاب
            </v-btn>
            <v-btn
                class="rounded-BigLg my-2"
                color="secondary"
                @click="isStart = false; startOrEndTransport(isStart)"
                :loading="submitLoading && !isStart"
                :disabled="submitLoading && isStart"
            >
                بدء رحلة العودة
            </v-btn>

            <v-alert v-if="alert" dismissible color="orange white--text" class="rounded-BigLg" width="300   ">
                يبدو أن إشعارات المتصفح معطلة. لتتمكن من تلقي الإشعارات المهمة من هذا الموقع، يرجى تفعيل الإشعارات من إعدادات المتصفح لديك.
            </v-alert>
        </div>
        <!-- footer -->
        <div class="d-flex justify-end mb-2">
            <v-bottom-navigation v-model="navigationBottom" color="primary" width="70" height="auto" class="elevation-0" >
                <a href="https://www.facebook.com/edunix.system" target="_blank">
                    <v-img src="@/assets/Powered By Edunix (Black).png" width="50" />
                </a>
            </v-bottom-navigation>

        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { whiteLogo } from '@/config/config.js'
import { busTripType } from '@/helper/enums'
export default {
    data () {
        return {
            navigationBottom: true,
            submitLoading: false,
            isStart: true,
            whiteLogo,
            permission: null,
            alert: false
        }
    },

    computed: {
        ...mapState({
            core: state => state.auth.core,
            tripId: state => state.transport.tripId,
            tripType: state => state.transport.tripType
        })
    },

    methods: {
        askForNotificationPermission () {
            if (Notification.permission === 'granted') {
                this.permission = 'granted'
            } else if (Notification.permission === 'denied') {
                this.permission = 'denied'
            } else {
                Notification.requestPermission().then(permission => {
                    this.permission = permission
                })
            }
        },
        startOrEndTransport () {
            this.submitLoading = true
            this.$store.dispatch('transport/startTrip', {
                tripType: this.isStart ? busTripType.oneWay : busTripType.return
            }).then(() => {
                this.$router.replace({
                    name: 'student-page',
                    query: {
                        isStart: this.isStart
                    }
                })
            }).catch(() => {
                this.submitLoading = false
            })
        }
    },

    created () {
        this.permission = Notification.permission

        // a trip is still running (eg. the app was reopened without logging out) - the
        // start-trip screen would only 409, so pick the trip back up where it left off
        if (this.tripId) {
            this.$router.replace({
                name: 'student-page',
                query: { isStart: this.tripType !== busTripType.return }
            })
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/variables.scss';
.bg {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: $background-color;
    border-bottom-left-radius: 165px;
}
.logo-circle {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    background-color: white;
}
</style>
